import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ActiveInstanceService } from '@core/services/instance/active-instance.service';
import { ActiveNamespaceService } from '@core/services/namespace/active-namespace.service';
import { TokenService } from '@core/services/token.service';
import { Auth } from 'aws-amplify';

export const PagesGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const instanceService = inject(ActiveInstanceService);
  const namespaceService = inject(ActiveNamespaceService);
  tokenService.applyAwsConfig();

  if (!tokenService.hasToken() && (state.url.startsWith('/dashboard') || state.url.startsWith('/create-instance'))) {
    router.navigate(['/login']);
    return false;
  }

  if (tokenService.hasToken() && (state.url.startsWith('/login') || state.url.startsWith('/register') || state.url.startsWith('/create-instance') || state.url.startsWith('/social'))) {
    return Auth.currentSession()
      .then((currentSession) => {
        try {
          const currentToken = currentSession.getIdToken();
          const agencyId = currentToken.payload["custom:agencies"];
          const instanceId = currentToken.payload["custom:instances"];

          if (agencyId) {
            localStorage.setItem("agencyId", agencyId);
          }
          if (instanceId) {
            localStorage.setItem("instanceId", instanceId);
          }
          if (!agencyId || !instanceId) {
            return true;
          }

          instanceService.setInstance();
          router.navigate(["dashboard", "home"], { replaceUrl: true });
          return false;
        } catch (e) {
          router.navigate(["/login"], { replaceUrl: true });
          return false;
        }
      })
      .catch(() => {
        router.navigate(["/logout"], { replaceUrl: true });
        return false;
      });
  }

  if (tokenService.hasToken() && state.url.startsWith('/dashboard')) {
    return Auth.currentSession()
      .then((currentSession) => {
        try {
          const currentToken = currentSession.getIdToken();

          if (!currentToken.payload["custom:instances"]) {
            router.navigate(["/create-instance"]);
            return false;
          }

          // Ensure instance is set only if it's valid
          instanceService.setInstance();

          const namespace = namespaceService.getNamespace();
          if (!namespace?.isSmbShowStudio && state.url.startsWith('/dashboard/studio')) {
            router.navigate(["/dashboard/home"]);
            return false;
          }

          return true;
        }
        catch (e) {
          router.navigate(["/login"], { replaceUrl: true });
          return false;
        }
      })
      .catch(() => {
        router.navigate(["/logout"], { replaceUrl: true });
        return false;
      });
  }

  return true;
};

